import { render, staticRenderFns } from "./NotePrompt.vue?vue&type=template&id=a96dfadc&scoped=true&"
import script from "./NotePrompt.vue?vue&type=script&lang=js&"
export * from "./NotePrompt.vue?vue&type=script&lang=js&"
import style0 from "./NotePrompt.vue?vue&type=style&index=0&id=a96dfadc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a96dfadc",
  null
  
)

export default component.exports